import { isPast } from 'date-fns';
/**
 * Returns the URI of a member photo.
 */
export const getMemberPhotoUri = (photo) => {
    if (!photo || isPast(new Date(photo.uriExpiresAt)))
        return undefined;
    return photo.uri;
};
